import { connect } from 'react-redux';
import { useContext } from 'react';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getKnmErknmPositionsSelectOptions } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { getDecisionPositionsSelectOptions } from 'DecisionPackage/MainModule/selectors/decisionSelectors';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { IDictionaryParticipantPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryParticipantPositionSelectOption';
import { IDictionaryPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryPositionSelectOption';
import { AgreementsContext } from 'KnmErknmPackage/ErkmAgreementsModule/AgreementsContext';

import styles from './AgreementsSignInfo.module.scss';

interface IAgreementsSignInfoProps {
  id: string;
  isWatchOnly: boolean;
  name: string;
}

interface IAgreementsSignInfoStoreProps {
  decisionPositionsSelectOptions:
    | IDictionaryPositionSelectOption[]
    | IDictionaryParticipantPositionSelectOption[]
    | undefined;
  positionsSelectOptions: IDictionaryPositionSelectOption[] | IDictionaryParticipantPositionSelectOption[] | undefined;
}

const AgreementsSignInfoWithoutStore = ({
  id,
  isWatchOnly,
  name,
  decisionPositionsSelectOptions,
  positionsSelectOptions,
}: IAgreementsSignInfoProps & IAgreementsSignInfoStoreProps) => {
  const { isKnm, isPm, isDecision } = useContext(AgreementsContext);

  return (
    <FieldBlock label={`Подпись соглашения`} className={styles.Wrapper}>
      <FieldBlock
        label={getTitleFieldWithRedStar({
          label: 'ФИО подписавшего соглашение',
          field: `${name}.fioSigner`,
          isDecision,
          isKnm,
          isPm,
        })}
        color="black"
        className={styles.FieldBlock}
        placementLabel="left"
        margin="bottom"
        id={`${id}.fioSigner`}
      >
        <TextInputField name={`${name}.fioSigner`} disabled={isWatchOnly} placeholder={'ФИО'} />
      </FieldBlock>
      <FieldBlock
        label={getTitleFieldWithRedStar({
          label: 'Должность лица, подписавшего соглашение',
          field: `${name}.titleSigner`,
          isDecision,
          isKnm,
          isPm,
        })}
        color="black"
        className={styles.FieldBlock}
        placementLabel="left"
        id={`${id}.titleSigner`}
        margin="bottom"
      >
        <SelectInputField
          name={`${name}.titleSigner`}
          placeholder="Выберите должность"
          options={isDecision ? decisionPositionsSelectOptions : positionsSelectOptions}
          isSearchable
          disabled={isWatchOnly}
          size="medium"
        />
      </FieldBlock>
    </FieldBlock>
  );
};

const mapStateToProps = (state: IRootState): IAgreementsSignInfoStoreProps => ({
  positionsSelectOptions: getKnmErknmPositionsSelectOptions(state),
  decisionPositionsSelectOptions: getDecisionPositionsSelectOptions(state),
});

export const AgreementsSignInfo = connect(mapStateToProps)(AgreementsSignInfoWithoutStore);
